import React from 'react';
import PropTypes from 'prop-types';

const styles = {
    content: {
        zIndex: 9999,
        background: '#3F51B5',
        position: 'fixed',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 8,
        paddingTop: 8,
        color: '#FFF',
        boxShadow: 'rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px',
    },
};

const Loading = ({ text }) => (
    <div style={styles.content}>
        <span>{text}</span>
    </div>
);

Loading.defaultProps = {
    text: 'Carregando...',
};

Loading.propTypes = {
    text: PropTypes.string,
};

export default Loading;
